import { render } from "./S343424.vue?vue&type=template&id=306bf5c2"
const script = {}
script.render = render

export default script